import MessagesStore from './messages'
import SettingsStore from './settings'

const STORE_TYPES = {
  message: MessagesStore,
  setting: SettingsStore
}

/**
 * Helper to get a new storage object of a specific type for a person
 */
export default function (user, type = 'message', options = {}) {
  const store = new STORE_TYPES[type](null, options)

  if (!store) {
    return
  }

  let userStore = store.get(user.id)
  if (!userStore) {
    userStore = store.create({
      user_id: user.id,
      user_created_at: user.get('created_at')
    })
  }

  return userStore
}
